// client/src/hooks/useSocket.js
import { useState, useEffect } from 'react';
import io from 'socket.io-client';
import { API_BASE_URL } from '../utils/media';

export const useSocket = () => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Establish connection. undefined (not '') tells socket.io-client to
    // connect to the page's own origin, which is what we want in production
    // once API_BASE_URL is relative/empty (see utils/media.js).
    const newSocket = io(API_BASE_URL || undefined);
    setSocket(newSocket);

    // Disconnect on cleanup
    return () => {
      newSocket.disconnect();
    };
  }, []);

  return socket;
};
